import styled, { css } from "styled-components";
import { motion } from "framer-motion";
import { fontMixin, getColorByService } from "../../../../../../../styles";
import { ServiceName } from "../../../../../../../constants";

interface ModuleItemProps {
	$isActive: boolean;
	$service: ServiceName;
}

export const MI_Container = styled(motion.div)<ModuleItemProps>`
	width: 220px;
	height: 86px;
	position: relative;

	display: grid;
	grid-template-rows: 45px 1fr;

	padding: 0 12px 10px;
	border-radius: 12px;
	background: #555;
	overflow: hidden;
	${({ $service }) => {
		const color = getColorByService($service);

		return css`
			${MI_Header} {
				background: ${color};
			}
		`;
	}}

	${({ $isActive, $service }) =>
		$isActive &&
		css`
			background: ${getColorByService($service)};
		`}
`;

export const MI_Shadow = styled(motion.div)`
	width: 220px;

	height: 86px;
	border-radius: 12px;
	box-shadow: 0 8px 18px rgba(0, 0, 0, 0.28);
`;

export const MI_Name = styled(motion.div)`
	text-transform: uppercase;
	${fontMixin({ size: 14 })};
	display: flex;
	justify-content: center;
`;

export const MI_Header = styled(motion.div)`
	width: 100%;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 0 0 10px 10px;
	${fontMixin({ size: 12 })};
`;

export const moduleItemVariants = {
	hidden: {
		opacity: 0,
		y: 14,
		scale: 0.92,
		filter: "blur(6px)",
	},
	visible: {
		opacity: 1,
		y: 0,
		scale: 1,
		filter: "blur(0px)",
		transition: {
			duration: 0.2,
			ease: [0.16, 1, 0.3, 1],
		},
	},
	exit: {
		opacity: 0,
		y: -8,
		scale: 0.96,
		filter: "blur(4px)",
		transition: {
			duration: 0.22,
			ease: "easeOut",
		},
	},
};
